import { IconButton, Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { CloseCircleOutline, Recognition, RecognitionCard } from '@aslanpay/portal-common-lib';
import { useCallback, useState } from 'react';

import useRecognition from 'app/hooks/useRecognition';

interface PotRecognitionDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  recognition: Recognition;
}

function PotRecognitionDetailsModal({
  isOpen,
  onClose,
  recognition,
}: PotRecognitionDetailsModalProps) {
  const { mutate: hideRecognition } = useRecognition.useHideRecognition();
  const { mutate: unhideRecognition } = useRecognition.useUnhideRecognition();

  const [pendingHideId, setPendingHideId] = useState<string | null>(null);

  const handleHide = useCallback(
    (id: string) => {
      setPendingHideId(id);
      hideRecognition(id, { onSettled: () => setPendingHideId(null) });
    },
    [hideRecognition]
  );

  const handleUnhide = useCallback(
    (id: string) => {
      setPendingHideId(id);
      unhideRecognition(id, { onSettled: () => setPendingHideId(null) });
    },
    [unhideRecognition]
  );

  if (!recognition) return null;

  const visibleRecognition = { ...recognition, adminHidden: false };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        bg="transparent"
        boxShadow="none"
        mx={4}
        sx={{
          width: '420px !important',
          maxWidth: '420px !important',
          minWidth: 'unset !important',
        }}
      >
        <IconButton
          variant="link"
          icon={<CloseCircleOutline boxSize="30px" />}
          aria-label="Close modal"
          onClick={onClose}
          position="absolute"
          top="16px"
          right="8px"
          zIndex={1}
          minW="auto"
          color="brand.purple"
        />
        <ModalBody p={0}>
          <RecognitionCard
            recognition={visibleRecognition}
            variant="grid"
            canModerate={false}
            onHide={handleHide}
            onUnhide={handleUnhide}
            isHidePending={pendingHideId === recognition.id}
            fitHeight
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default PotRecognitionDetailsModal;
